import componentPackNavbar from "../ui-components/navbar";
import componentPackNotice from "../ui-components/notice";
import componentPackSwiper from "../ui-components/swiper";
import componentPackPcNavbar from "../ui-components/pcnavbar";
import componentPackGoodslist from "../ui-components/goodslist";
import componentPackBanner from "../ui-components/banner";
import componentPackIndex from "../ui-components/index";
import componentPackSpacing from "../ui-components/spacing";
import componentPackNews from "../ui-components/news";
import config from '@/config';
import VueI18n from "vue-i18n";
import messages from "@/pages/design/design_i18n";
// const messages = require('@/pages/design/design_i18n')

import store from "@/store/index";
var i18n = new VueI18n({
  locale: window.localStorage.lang || config.lang,
  messages: messages.messages
});

/**
 * hidden 隐藏，不显示在工具栏
 * maxNum Number 最大可配置数
 * topDisplay Bool 最顶部显示
 * bottomDisplay Bool 最底部显示
 * onlyCanConfig Bool 是否只能配置数据，不能删除 copy
 * @type {*[]}
 */
var tools = [{
  groupName: i18n.t("left.publicComponent"),
  componentList: [{
    title: i18n.t("left.navbar"),
    maxNum: 1,
    order: 1,
    draggable: false,
    icon: "el-icon-picture",
    platform: "m",
    name: "Navbar",
    key: 1,
    type: i18n.t('left.pcAndMobile'),
    componentPack: componentPackNavbar
  }, {
    title: i18n.t("left.notice"),
    maxNum: 1,
    order: 2,
    draggable: false,
    icon: "el-icon-picture",
    platform: "m",
    name: "Notice",
    key: 2,
    type: i18n.t('left.pcAndMobile'),
    componentPack: componentPackNotice
  }, {
    title: i18n.t("left.swiper"),
    maxNum: 50,
    icon: "el-icon-picture",
    platform: "m",
    name: "Swiper",
    key: 4,
    type: i18n.t('left.pcAndMobile'),
    componentPack: componentPackSwiper
  }, {
    title: i18n.t("left.banner"),
    maxNum: 50,
    icon: "el-icon-picture",
    platform: "m",
    name: "Banner",
    key: 4,
    type: i18n.t('left.pcAndMobile'),
    componentPack: componentPackBanner
  }, {
    title: i18n.t("left.goodslist"),
    maxNum: 50,
    icon: "el-icon-picture",
    platform: "m",
    name: "Goodslist",
    key: 2,
    type: i18n.t('left.pcAndMobile'),
    componentPack: componentPackGoodslist
  }, {
    title: i18n.t("left.news"),
    maxNum: 50,
    icon: "el-icon",
    platform: "m",
    name: "News",
    type: i18n.t('left.pcAndMobile'),
    componentPack: componentPackNews
  }, {
    title: i18n.t("left.spacing"),
    maxNum: 50,
    platform: "m",
    name: "Spacing",
    key: 10,
    type: i18n.t('left.pcAndMobile'),
    componentPack: componentPackSpacing
  }]
}, {
  groupName: i18n.t("left.mobileComponent"),
  componentList: [{
    title: i18n.t("left.index"),
    maxNum: 1,
    icon: "el-icon-picture",
    platform: "m",
    name: "Index",
    key: 2,
    type: i18n.t('com.mobile'),
    componentPack: componentPackIndex
  }]
}];
export default tools;